import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../environments/environment";
import { IResponse } from "../../interface";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private http = inject(HttpClient);

  login(userData): Observable<any> {
    return this.http.post<IResponse>(`${environment.apiEndpoint}/user/login`, userData);
  }

  register(userData): Observable<any> {
    return this.http.post<IResponse>(`${environment.apiEndpoint}/user/register`, userData);
  }

  confirmEmail(tokenId): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/user/confirm/` + tokenId);
  }

  resendEmail(email: string): Observable<any> {
    return this.http.post<IResponse>(`${environment.apiEndpoint}/user/resendConfirmationEmail`, {
      email,
    });
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.put<IResponse>(`${environment.apiEndpoint}/user/resetPasswordRequest`, {
      email,
    });
  }

  resetPassword(token: string, password: string): Observable<any> {
    return this.http.put<IResponse>(`${environment.apiEndpoint}/user/resetPassword/${token}`, {
      password,
    });
  }

  getInvitationData(token: string): Observable<any> {
    return this.http.get<IResponse>(`${environment.apiEndpoint}/user/${token}`);
  }

  registerWithInvitation(userData, token): Observable<any> {
    return this.http.put<IResponse>(`${environment.apiEndpoint}/user/invited/${token}`, userData);
  }
}
